export const production = {
  api: '/api/',
};

export const development = {
  api: '/api/',
};
